import { IProductionLanguage } from "./types";

import enLanguage from "./languages/lang-en.json";
import esLanguage from "./languages/lang-es.json";
import ptLanguage from "./languages/lang-pt.json";

const languages = {
  "en-us": enLanguage,
  "es-mx": esLanguage,
  "pt-br": ptLanguage
};

export const getLanguage = (languageCode: "es-mx" | "pt-br" | "en-us"): IProductionLanguage => {
  return languages[languageCode];
};
